<template>
  <div class="drawer-box">
    <el-drawer
    :visible.sync="visible"
    :direction="direction"
    :before-close="handleClose">
    <span slot="title" class="title">{{$t('complaintList.highSearch')}}</span>
    <div class="filter-box">
      <div class="row">
        <span class="label">{{$t('warehouseDetail.name')}}：</span>
        <div class="col">
            <el-autocomplete
            v-model="form.name"
            :trigger-on-focus="false"
            name="name"
            value-key="name"
            clearable
            :fetch-suggestions="function (queryString, cb) { return querySearchAsync(queryString, cb, 'name') }"
            :placeholder="$t('goodsManIndex.inputName')"
            @select="function (item) { return handleSelect(item, 'name') }"
            ></el-autocomplete>
        </div>
      </div>
    <div class="row">
        <span class="label">{{$t('applyChild.code')}}：</span>
        <div class="col">
            <el-autocomplete
            v-model="form.code"
            :trigger-on-focus="false"
            name="code"
            value-key="code"
            clearable
            :fetch-suggestions="function (queryString, cb) { return querySearchAsync(queryString, cb, 'code') }"
            :placeholder="$t('goodsManIndex.inputCode')"
            @select="function (item) { return handleSelect(item, 'code') }"
            ></el-autocomplete>
        </div>
      </div>
    <div class="row">
        <span class="label">{{$t('applyChild.model')}}：</span>
        <div class="col">
            <el-autocomplete
            v-model="form.model"
            :trigger-on-focus="false"
            name="model"
            value-key="model"
            clearable
            :fetch-suggestions="function (queryString, cb) { return querySearchAsync(queryString, cb, 'model') }"
            :placeholder="$t('goodsManIndex.inputModel')"
            @select="function (item) { return handleSelect(item, 'model') }"
            ></el-autocomplete>
        </div>
      </div>
    <div class="row">
        <span class="label">{{$t('applyChild.size')}}：</span>
        <div class="col">
            <el-autocomplete
            name="specification"
            value-key="specification"
            :trigger-on-focus="false"
            v-model="form.specification"
            :fetch-suggestions="function (queryString, cb) { return querySearchAsync(queryString, cb, 'specification') }"
            :placeholder="$t('goodsManIndex.inputSize')"
            clearable
            @select="function (item) { return handleSelect(item, 'specification') }"
            ></el-autocomplete>
        </div>
      </div>
    </div>
    <div class="btns">
        <el-button class="cancel-btn" @click="handleClose">{{$t('indexTags.cancel')}}</el-button>
        <el-button class="confirm-btn" @click="submit">{{$t('indexTags.sure')}}</el-button>
    </div>
    </el-drawer>
  </div>
</template>

<script>
import { getProductFilter, getPartFilter, getMaterialFilter } from "../../api/goods/index"
  export default {
    props: {
      visible: { default: false },
      defaultInfo: { 
        default: () => {
            return {};
        }
      },
    },
    data() {
      return {
        direction: 'rtl',
        form: {
            name: '',
            code: '',
            model: '',
            specification: '',
        },
        api: null,
        nameOptions: [],
        codeOptions: [],
        modelOptions: [],
        specificationOptions: [],
        timeout:  null
      }
    },
    created() {
      console.log(this.$route.meta.type);
      console.log(this.defaultInfo);
      this.form.name = this.defaultInfo && this.defaultInfo.name ? this.defaultInfo.name : '';
      this.form.model = this.defaultInfo && this.defaultInfo.model ? this.defaultInfo.model : '';
      this.form.code = this.defaultInfo && this.defaultInfo.code ? this.defaultInfo.code : '';
      this.form.specification = this.defaultInfo && this.defaultInfo.specification ? this.defaultInfo.specification : '';
      this.getFilterList('name');
      this.getFilterList('model');
      this.getFilterList('code');
      this.getFilterList('specification');
    },
    methods: {
      handleApiChange(e) {
        switch(e) {
            case 'product':
                return getProductFilter;
            case 'part':
                return getPartFilter;
            case 'material':
                return getMaterialFilter;
        }
      },
      querySearchAsync(queryString, cb, target) {
        var options = [];
        options = this[target + 'Options'];
        console.log(target);
        console.log('options', options);
        var results = queryString ? options.filter(this.createFilter(queryString, target)) : options;

        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
        cb(results);
        }, 3000 * Math.random());
      },
      createFilter(queryString, target) {
        return (state) => {
          return (state[target].toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      handleSelect(item, target) {
        this.form[target] = item[target];
      },
      handleClose() {
        this.$emit("update:visible", false);
      },
      submit() {
        this.$emit('faction', this.form);
        this.handleClose();
      },
      async getFilterList(type) {
        this.api = this.handleApiChange(this.$route.meta.type);
        const res = await this.api({
            selectCondition: type
        })
        console.log('filter =>', res.data);
        if(res.data && res.data.code === 200) {
            this[type + 'Options'] = res.data.data;
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
/deep/ #el-drawer__title .title {
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #333333;
}

.filter-box {
    position: relative;
    padding: 0 51px;
}

.row {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.label {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    min-width: 15%;
}

.col {
    flex: 1;
}

.btns {
    position: absolute;
    left: 50%;
    bottom: 93px;
    transform: translate(-50%, 0);
    .cancel-btn {
        color: #50C4CB;
        border-color: #50C4CB;
    }
    .confirm-btn {
        background-color: #50C4CB;
        color: #fff;
    }
}
</style>